export default "__VITE_ASSET__2c6a460d__$_?component__"